<script lang="ts">
    import {onMount} from "svelte";

    export let spaceUserAccessLog;

    onMount(() => {
    });


</script>

<tr class="admin-space-user-access-log-row-view">
    <td>
        { spaceUserAccessLog.space_name }
    </td>
    <td class="user-cell">
        <div class="company-department-job">
            <div>
                { spaceUserAccessLog.company_name }
            </div>
            <div>
                { spaceUserAccessLog.department_name }
            </div>
            <div>
                {#if spaceUserAccessLog.job_name != null}
                    { spaceUserAccessLog.job_name }
                {/if}
            </div>

        </div>
        <div>
            { spaceUserAccessLog.user_name }
        </div>
    </td>
    <td>
        <div>
            { spaceUserAccessLog.access_date }
        </div>
        <div>
            { spaceUserAccessLog.access_count }回
        </div>
    </td>

    <td class="session-cell">
        <div>
            { spaceUserAccessLog.session_start_at } 〜
            {#if spaceUserAccessLog.session_end_at != null}
                { spaceUserAccessLog.session_end_at }
            {:else}
                接続中
            {/if}
        </div>
        <div class="detail">
            <div>
                latest beat: { spaceUserAccessLog.latest_session_beat_at }
            </div>
            <div>
                { spaceUserAccessLog.session_minutes }min
            </div>


        </div>
    </td>


</tr>
<style lang="scss">
    .admin-space-user-access-log-row-view {
        .user-cell {
            .company-department-job {
                display: flex;
                gap: 8px;
                font-size: 0.75em;
                flex-wrap: wrap;
            }
        }

        .session-cell {
            .detail {
                display: flex;
                gap: 8px;
                font-size: 0.75em;
                opacity: 0.75;
            }
        }
    }
</style>